import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import tiling from '../../images/blue-tile.png'
import {theme} from '../../theme.js'
import { ThemeProvider } from '@emotion/react';
import { Container } from '@mui/system';
export const ControlledAccordions= () => {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  
  const contents = [
    {"display": `Do you have safety procedures regarding viruses such as COVID 19?`, 
    "text" : `We have a rigorous regimen to disinfect all high-touch surfaces between games.
     In addition, since scientists say that most COVID cases come from transmission through 
     the air of small particles rather than from surfaces, we have upgraded our air cleaning
      system to include a NASA-developed UV filter to disinfect the air that circulates in 
      our rooms.`},
    {"display": `What else do we ask of the players?`, 
    "text" :  ` We ask that you stay home when you are sick.
    We request that each person in your group wear a face mask and begin the game with washed or sanitized hands.
    To keep you safe, we request you do not drink alcohol or take drugs before or during your session.
    There is a standard waiver to fill out for each player. We hope you will complete it at home before arriving. `
    },
    {"display": `Will I play with other people?`,
    "text" : `All of our games are private and have a minimum number of players needed, so that you can enjoy the
     experience with your group only`
    },
    {
      "display": `Why is There a Minimum Number of Players?`,
      "text" : `We want you to have the best experience possible, so we suggest that you bring a group that has 
      the minimum number of players needed to complete the challenges. Without the minimum number of players, it 
      may be difficult to succeed in the game.`
    },
    {
      "display": `Will the room really be locked?`,
      "text" : `No, your safety is our highest priority, so we do not really lock you in the room. You are free to
       step out for emergencies, the bathroom, etc. Our bathroom is much nicer than those medieval Priveys. And 
       way easier than going while wearing a space suit, diving suit or a suit of armor.`
    },
    {
      "display": `Will you stop the game for us to take a break?`,
      "text" : `Nope, the timer will continue to run if a player steps out of the room. Because our games are booked
       in advance for each group, we must stick to the game’s time limit.`
    },
    {
      "display" : `How Early Should I Arrive for My Adventure?`,
      "text" : `Please arrive 10 to 15 minutes prior to your game start time. Games will begin exactly at their start
       times. We don't want you to miss any of the fun!`
    },
    {
      "display" : `What is the Cancellation Policy?`,
      "text" : `We understand that plans change, so reservations can be cancelled up to 48 hours before your game for
       a full refund! Give us a call or click “Manage This Booking” in your confirmation email to cancel.`
    },
    {
      "display" : `What if We are Running Late or Need to Reschedule?`,
      "text" : `If you're running late...We will do our best to accommodate you. For example, if you're 5 minutes
      late, you may lose just 5 minutesof game time. If too much time has passed, and a booking directly follows your 
      time slot, we may offeryou a later slot that day if it is available. Because our games are typically booked several
      days in advance wemay not be able to fit you in the same day. but if there is a way to reschedule we will try to
      find you a new spot. 
      
      If you need to reschedule...Please give us a call if your game time is in less than 72 hours. Cancellations within
       less than 72 hours are not refunded.`
    },
    {
      "display" : `Are the adventures family-friendly?`,
      "text" : `Definitely. We welcome participants aged 10 and up. An adult must be present in the room with 
      participants under age 15. Anyone under 18 must have a waiver signed by a parent or guardian.`
    },
    {
      "display" : `What should I wear to play VR?`,
      "text" : `There are a few tips we can offer:

        A VR escape room is an active experience, so dress in layers and light, comfortable clothing.
        Make sure to wear closed-toed shoes (no flip-flops) for safety reasons
        Sometimes, large glasses cannot fit into the headset. Most glasses are fine, but&nbsp;if you are able to wear 
        contact lenses, please do so. Hair must also fit in a headset, so wearing hair down may be more comfortable than
         ponytails, etc.`
    },
    {
      "display" : `Can We Bring Food or Drinks into the Adventure?`,
      "text" : `We ask that no food or drink is taken into the game rooms. Snacks and drinks can be purchased and consumed
       in our lobby. Also, our water fountain has a water bottle filler.`
    },
    {
      "display" : `Who enjoys escape rooms?`,
      "text" : `Anyone who likes challenges An escape room is fun for date nights, family outings, birthday parties,
       adventures with friends, bachelor or bachelorette parties and corporate groups or team building.`
    }
  ]
  
  return (
    <ThemeProvider theme = {theme}>
        {contents.map((entry) => (
          <Container display="flex">
          <Accordion expanded={expanded === `${entry.display}`} onChange={handleChange(`${entry.display}`)}
          style={{backgroundImage:`url(${tiling})`, backgroundAttachment: "fixed", color:"white"}}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={entry.display}
              id={entry.display}
            >
              <ExpandMoreIcon/>
              <Typography variant = "h5" fontFamily={"Sans-Serif"}>
                {entry.display}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant = "h6" marginLeft={"50px"} fontFamily={"Sans-Serif"}>
                {entry.text}
              </Typography>
            </AccordionDetails>
          </Accordion>
          </Container>  
        ))}
    </ThemeProvider>
  );
}